/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import { Context } from 'context/AuthContext';
import { GET_LIST_AVISO } from 'services/Aviso';
import { COUNT_PENDENCIA_USUARIO_ATUAL } from 'services/Pendencia';
import { COUNT_RASCUNHO_USUARIO_ATUAL } from 'services/Rascunho';

import rascunho from 'assets/imgs/icons/rascunho.png';
import pendencias from 'assets/imgs/icons/pendencias.png';
// import onoff from 'assets/imgs/icons/plano_midias_on_off.png';
// import atendimento from 'assets/imgs/icons/atendimento_ao_usuario.png';
import consultar from 'assets/imgs/icons/consultar.png';
import materiais from 'assets/imgs/icons/icon_materiais.svg';
// import histsolicitacoes from 'assets/imgs/icons/icon_histsolicitacoes.svg';
import artesazonal from 'assets/imgs/icons/relatorios.png';
import bancoartes from 'assets/imgs/icons/plano_midias_on_off.png';
// import relatorios from 'assets/imgs/icons/relatorios.png';
// import artefacil from 'assets/imgs/icons/artes_facil.png';

import { GET_SITE_CONFIG } from 'services/SysConfig';
import './styles.scss';

const ContentHome = () => {
  const [warnings, setWarnings] = useState([]);
  const { showLoader } = useContext(Context);
  const [corPendencia, setCorPendencia] = useState([]);
  const [corRascunho, setCorRascunho] = useState([]);
  const [mensagem, setMensagem] = useState('');

  async function getHomeMessage() {
    const data = await GET_SITE_CONFIG({ keyFilter: 'MENSAGEM_HOME' });
    if (data.value != null && data.value.length > 0) {
      return data.value[0].value;
    }

    return '';
  }

  useEffect(() => {
    async function fetchData() {
      showLoader(true);

      const msg = await getHomeMessage();
      setMensagem(msg);

      const corPendenciaResult = await COUNT_PENDENCIA_USUARIO_ATUAL();
      setCorPendencia(corPendenciaResult.value);

      const countUsuarioAtual = await COUNT_RASCUNHO_USUARIO_ATUAL();
      setCorRascunho(countUsuarioAtual.value);

      const warningsResult = await GET_LIST_AVISO();
      setWarnings(warningsResult.value);

      showLoader(false);
    }
    fetchData();
  }, []);

  return (
    <>
      <div className="wrapper-choose-the-costumer">
        <div className="warnings">
          <Carousel>
            {warnings?.map((item) => {
              return (
                <Carousel.Item key={item.avisoId}>
                  {item.urlRedirecionamento ? (
                    <a
                      href={item.urlRedirecionamento}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={item.urlImagem}
                        alt={item.texto}
                      />
                    </a>
                  ) : (
                    <img
                      className="d-block w-100"
                      src={item.urlImagem}
                      alt={item.texto}
                    />
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>

        {/* <div className="actions"> */}
        <div className="actions">
          <div>
            {/* Solicitar Materiais ------------------------------------------------------------ */}
            <Link to="/pedido-materiais">
              <div>
                <div className="button-content">
                  <div>
                    <img src={materiais} alt="Materiais Gráficos" />
                  </div>
                  <div className="btn-divider" />
                  <div>Solicitar Diversos Materiais</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Solicite materiais personalizados com qualquer layout,
                    produto ou dimensões necessárias
                  </p>
                </div>
              </div>
            </Link>
            {/* Rascunho ----------------------------------------------------------------------- */}
            <Link to="/rascunho">
              <div className={corRascunho > 0 ? 'action-alert' : ''}>
                <div className="button-content">
                  <div>
                    <img src={rascunho} alt="Rascunhos" />
                  </div>
                  <div className="btn-divider" style={{ marginLeft: '10px' }} />
                  <div>Rascunhos</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    LISTA DE RASCUNHOS (SOLICITAÇÕES COM PREENCHIMENTO INICIADO
                    MAS NÃO FINALIZADAS)
                  </p>
                </div>
              </div>
            </Link>

            {/* Midias Digitais ---------------------------------------------------------------- */}
            {/* <Link to="/pedido-materiais?materialComunicacaoTipo=MD">
              <div>
                <div className="button-content">
                  <div>
                    <img src={artefacil} alt="Mídias Digitais" />
                  </div>
                  <div className="btn-divider" />
                  <div>Solicitar Mídias Digitais</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    Solicite artes digitais personalizadas com qualquer layout,
                    produto ou dimensões necessárias.
                  </p>
                </div>
              </div>
            </Link> */}
          </div>

          <div>
            {/* Pendencias --------------------------------------------------------------------- */}
            <Link to="/pendencias">
              <div className={corPendencia > 0 ? 'action-alert' : ''}>
                <div className="button-content">
                  <div>
                    <img src={pendencias} alt="pendencias" />
                  </div>
                  <div className="btn-divider" />
                  <div>Pendências</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    PÁGINA PARA VISUALIZAÇÃO DAS SUAS PENDÊNCIAS E APROVAÇÃO DE
                    ARTES
                  </p>
                </div>
              </div>
            </Link>

            {/* Historico ---------------------------------------------------------------------- */}
            {/* <Link to="/historico-solicitacoes">
              <div>
                <div className="button-content">
                  <div>
                    <img
                      src={histsolicitacoes}
                      alt="Histórico de Solicitações"
                    />
                  </div>
                  <div className="btn-divider" />
                  <div>Histórico de Solicitações</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    PÁGINA PARA VISUALIZAÇÃO DO HISTÓRICO DAS SUAS SOLICITAÇÕES
                    E FACILITAR SOLICITAR NOVAMENTE
                  </p>
                </div>
              </div>
            </Link> */}

            {/* Artes Sazonais ---------------------------------------------------------------------- */}
            <a target='_blank' rel="noreferrer" href="https://multimaxi365-my.sharepoint.com/personal/diagramador3_multimaxi_com_br/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fdiagramador3%5Fmultimaxi%5Fcom%5Fbr%2FDocuments%2FMCCAIN%2FARTES%20SAZONAIS&ga=1">
              <div>
                <div className="button-content">
                  <div>
                    <img src={artesazonal} alt="Artes Sazonais" />
                  </div>
                  <div className="btn-divider" />
                  <div>Artes Sazonais</div>
                </div>
                <div className="button-content-hover">
                  <p>Artes Sazonais</p>
                </div>
              </div>
            </a>
          </div>

          <div>
            {/* Consulta ----------------------------------------------------------------------- */}
            <Link to="/consulta">
              <div>
                <div className="button-content">
                  <div>
                    <img src={consultar} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>SOLICITAÇÕES EM ANDAMENTO</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    PÁGINA DE CONSULTA PARA VISUALIZAR AS SOLICITAÇÕES EM
                    ANDAMENTO E SEU STATUS
                  </p>
                </div>
              </div>
            </Link>
            {/* Banco de Artes ----------------------------------------------------------------- */}
            <Link to="/banco-de-artes">
              <div>
                <div className="button-content">
                  <div>
                    <img src={bancoartes} alt="Consultar" />
                  </div>
                  <div className="btn-divider" />
                  <div>Banco de artes</div>
                </div>
                <div className="button-content-hover">
                  <p>
                    BANCO DAS ARTES JÁ FEITAS NA PLATAFORMA PARA CONSULTA E PARA
                    SOLICITAR NOVAMENTE
                  </p>
                </div>
              </div>
            </Link>
          </div>
          {/* Horario de Atendimento ----------------------------------------------------------- */}
          <div className="d-flex justify-content-center text-center p-3 pt-4 text-dark text-uppercase">
            <h5 className="font-weight-bold home-horario-atendimento">
              {mensagem}
            </h5>
          </div>

          {/* <div>


            <Link to="/relatorios">
              <div>
                <div className="button-content">
                  <div>
                    <img src={relatorios} alt="Relatórios" />
                  </div>
                  <div className="btn-divider" />
                  <div>Relatórios</div>
                </div>
                <div className="button-content-hover">
                  <p>Relatórios.</p>
                </div>
              </div>
            </Link>
          </div> */}
        </div>
      </div>
      {/* <div className="d-flex justify-content-center text-center mb-3">
        <h5 className="font-weight-bold home-horario-atendimento">
          {mensagem}
        </h5>
      </div> */}
    </>
  );
};

const App = () => {
  return (
    <>
      <HeaderApp />
      <ContentHome />
      <Bottom />
    </>
  );
};

export default App;
